<template>
  <v-sheet class="info-content">
    <BranchSwitcher :branch="branch" :merchant-branches="merchantBranches" />
    <v-divider />

    <!-- address -->
    <div class="info-block">
      <div class="info-text d-flex justify-space-between align-center">
        <p class="branch-address ma-0">{{ fullAddress }}</p>
        <v-btn class="action__btn" color="orange50" height="32" variant="text" @click="openBranchMapModal">
          <funnow-svg-icon max-width="24" height="24" :color="CUSTOM_COLORS.orange50" image-path="map.svg" />
        </v-btn>
      </div>
      <v-divider />
    </div>

    <!-- phone -->
    <div v-if="branch.noticePhone" class="info-block">
      <div class="info-text d-flex justify-space-between align-center">
        <p class="branch-address ma-0">{{ branch.noticePhone }}</p>
        <v-btn as="a" class="action__btn" color="orange50" height="32" variant="text" :href="`tel:${branch.noticePhone}`">
          <funnow-svg-icon max-width="24" height="24" :color="CUSTOM_COLORS.orange50" image-path="phone.svg" />
        </v-btn>
      </div>
      <v-divider />
    </div>

    <div v-if="branch.opening_hours" class="info-block">
      <div class="info-text">
        <div class="info-title d-flex justify-space-between">
          <h3 class="my-0 wd-text-olg wd-font-500">{{ $t('open_hour') }}</h3>
          <v-btn color="orange50" height="32" variant="text" aria-label="Expand Button" @click="openingHoursExpandStatus = !openingHoursExpandStatus">
            <div>
              <funnow-svg-icon
                max-width="24"
                height="24"
                :color="CUSTOM_COLORS.orange50"
                :image-path="`chevron-${openingHoursExpandStatus ? 'up' : 'down'}_orange.svg`"
              />
            </div>
          </v-btn>
        </div>
        <div v-if="openingHoursExpandStatus" class="opening-hours-info mt-5">
          <div ref="openingHours" v-html="nl2br(branch.opening_hours)" />
        </div>
      </div>
      <v-divider />
    </div>

    <template v-if="branchIntro">
      <BranchIntro :intro="branchIntro" />
      <v-divider />
    </template>

    <!-- 預訂注意事項 -->
    <BranchNotice v-if="needToKnowItems.length" :items="needToKnowItems" />

    <branch-map-modal ref="branchMapModal" :branch="branch" />
  </v-sheet>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue'
import utils from '@/utils'

import BranchMapModal from '@/components/dialog/branch-map-modal.vue'
import FunnowSvgIcon from '@/components/icons/funnow-svg-icon.vue'
import BranchSwitcher from '@/components/BranchSwitcher.vue'
import BranchIntro from '@/components/BranchIntro.vue'
import BranchNotice from '@/components/BranchNotice.vue'
import { useFunbookBranchFromStore } from '@/composition/useFunbookV2'
import { CUSTOM_COLORS } from '@/constants/theme'

defineOptions({
  name: 'BranchInfoCard',
})

const props = withDefaults(defineProps<{ branch: any }>(), {
  branch: () => ({}),
})

const { branch } = toRefs(props)
const { fullAddress } = useAddress(branch)

const branchMapModal = useTemplateRef('branchMapModal')

const bid = computed(() => props.branch.bid)

const { merchantBranches, branchIntro, needToKnowItems } = useFunbookBranchFromStore(bid)

const openingHoursExpandStatus = ref(false)

function nl2br(text: string) {
  return utils.nl2br(text)
}

function openBranchMapModal() {
  branchMapModal.value?.showModal()
}
</script>
<style lang="scss" scoped>
.info-content {
  width: 100%;
  .info-text {
    margin: 16px 0;
    padding-left: 20px;
    .info-title {
      font-size: 20px;
      font-weight: 500;
    }
    .intro-info {
      overflow: hidden;
      &.expaned {
        max-height: unset;
      }
    }
    .intro-info {
      max-height: 66px;
    }
  }
}

.action__btn {
  font-size: $baseFontSize;
  &--center {
    margin: auto;
    display: block;
  }
}
</style>
